var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',{staticClass:"q-mt-none q-mb-md text-grey-8"},[_vm._v("Car")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }